import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { StyledMaintenanceBanner, StyledMaintenanceBannerContent } from './Header.styled';

const deadline = Date.parse('2025-04-24T05:30:00.000+01:00');

export default function MaintenanceBanner() {
  const isBeforeDeadline = Date.now() < deadline;

  if (isBeforeDeadline) {
    return (
      <StyledMaintenanceBanner>
        <StyledMaintenanceBannerContent>
          <Typography variant="p" color="white">
            <FormattedMessage id="maintenance_banner.text" />
          </Typography>
        </StyledMaintenanceBannerContent>
      </StyledMaintenanceBanner>
    );
  }
  return null;
}
